import { SxProps } from '@mui/system';
import { FC } from 'react';
import { styled, Theme } from '@mui/material/styles';
import Box from '../Box';

export interface ButtonsProps {
  /**
   * Spacing between buttons.
   */
  gutter?: number;
  sx?: SxProps<Theme>;
}

const ButtonsRoot = styled(Box, {
  name: 'O2Buttons',
  slot: 'Root',
  shouldForwardProp: (prop) => prop !== 'gutter',
})<ButtonsProps>(({ theme, gutter }) => ({
  margin: gutter ? `-${theme.spacing(gutter)}` : undefined,
  '& > .MuiButton-root': {
    margin: gutter ? theme.spacing(gutter) : undefined,
  },
}));

/**
 * Wrapper for multiple buttons in one row.
 */
const Buttons: FC<ButtonsProps> = ({ gutter, children, ...other }) => {
  return (
    <ButtonsRoot gutter={gutter} {...other}>
      {children}
    </ButtonsRoot>
  );
};

Buttons.defaultProps = {
  gutter: 1,
};

export default Buttons;
